module.exports = __webpack_public_path__ + "30ed019c10e7044f26649ac9e9a84c8a.svg";